module.exports = __webpack_public_path__ + "static/media/brsrBannerImage3.82779382.svg";